<template>
  <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="34" height="24" rx="4" :fill="fill" />
    <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" :stroke="strokeColor" stroke-opacity="0.1" />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.2741 9.07422C21.2624 9.1523 21.2488 9.23209 21.2337 9.31409C20.7116 12.0847 18.9254 13.0419 16.6441 13.0419H15.4825C15.2035 13.0419 14.9684 13.2512 14.925 13.5357L14.1619 18.5389C14.1336 18.7258 14.2729 18.894 14.4552 18.894H16.5153C16.7592 18.894 16.9665 18.7109 17.0049 18.4622L17.0251 18.354L17.413 15.8098L17.438 15.6703C17.4759 15.4208 17.6836 15.2375 17.9275 15.2375H18.2356C20.2316 15.2375 21.7942 14.4 22.2509 11.9761C22.4416 10.9636 22.3429 10.1181 21.838 9.52353C21.6853 9.34427 21.4958 9.19544 21.2741 9.07422Z"
      :fill="iconFill"
      fill-opacity="0.6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.7288 8.84993C20.649 8.82586 20.5667 8.80411 20.4823 8.78443C20.3974 8.76525 20.3105 8.74826 20.2211 8.73335C19.9079 8.68106 19.5647 8.65625 19.1971 8.65625H16.0941C16.0176 8.65625 15.945 8.67409 15.8801 8.70635C15.7369 8.77747 15.6306 8.9175 15.6049 9.08894L14.9447 13.4105L14.9258 13.5365C14.9692 13.252 15.2043 13.0427 15.4833 13.0427H16.6449C18.9261 13.0427 20.7124 12.085 21.2345 9.31488C21.2501 9.23289 21.2632 9.15309 21.2749 9.07501C21.1428 9.00255 20.9998 8.9406 20.8457 8.88781C20.8077 8.87473 20.7684 8.86215 20.7288 8.84993Z"
      :fill="iconFill"
      fill-opacity="0.6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.6047 9.08911C15.6304 8.91767 15.7367 8.77764 15.8799 8.70701C15.9453 8.67463 16.0174 8.65679 16.0939 8.65679H19.1969C19.5645 8.65679 19.9077 8.68171 20.2208 8.73401C20.3103 8.7488 20.3972 8.76591 20.4821 8.78509C20.5665 8.80464 20.6488 8.82651 20.7286 8.85046C20.7682 8.86268 20.8075 8.87539 20.8459 8.88798C20.9999 8.94077 21.1431 9.00321 21.2752 9.07518C21.4305 8.05131 21.2739 7.35419 20.7383 6.72293C20.1478 6.02789 19.0821 5.73047 17.7184 5.73047H13.7593C13.4808 5.73047 13.2431 5.93979 13.2001 6.22475L11.5511 17.0283C11.5186 17.2421 11.6781 17.4349 11.8866 17.4349H14.3308L15.6047 9.08911Z"
      :fill="iconFill"
      fill-opacity="0.6"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps({
  fill: {
    type: String,
    default: 'var(--color-icon-payment)'
  },
  iconFill: {
    type: String,
    default: '#F1E7D1'
  },
  strokeColor: {
    type: String,
    default: '#F1E7D1'
  }
})
</script>
